export type RestrictedFeature =
  | 'chats'
  | 'follow-ups'
  | 'cashflow-analyse'
  | 'contracts-termination'
  | 'contracts-transfer'
  | 'insign'
  | 'media-studio'
  | 'depots';

export interface RestrictedPageConfig {
  readonly icon: string;
  /** Display name of the add-on, set when the feature is bought as an add-on instead of via a package. */
  readonly addonName?: string;
  /** Package that includes the feature, set when it is not part of Plus (e.g. Plus Investment). */
  readonly packageName?: string;
  readonly title: string;
  readonly description: string;
  readonly features: readonly string[];
  readonly previewLabel: string;
  readonly previewHeadline: string;
  readonly previewHeadlineHighlight: string;
  readonly previewSubline: string;
  /** Promo video for the preview card (label & headlines are baked in). Without it → static headline placeholder. */
  readonly video?: string;
}
